import classNames from "classnames";
import PropTypes from "prop-types";
import { ReactComponent as CheckIcon } from "../Assets/icons/check.svg";

const CheckboxPanel = ({
  checked,
  onChange,
  children,
  expandContent,
  className,
  disabled = false,
}) => {
  const handleClick = () => {
    if (!disabled) {
      onChange(!checked);
    }
  };

  return (
    <div
      className={classNames("miltis__checkbox-panel", className, {
        "miltis__checkbox-panel--checked": checked,
        "miltis__checkbox-panel--disabled": disabled,
      })}
    >
      <button
        type="button"
        className="miltis__checkbox-panel--header"
        onClick={handleClick}
        disabled={disabled}
      >
        <div
          className={classNames("miltis__checkbox-panel--box", {
            "miltis__checkbox-panel--box--checked": checked,
          })}
        >
          {checked && <CheckIcon />}
        </div>
        <div className="miltis__checkbox-panel--label">{children}</div>
      </button>
      {checked && expandContent && (
        <div className="miltis__checkbox-panel--content">{expandContent}</div>
      )}
    </div>
  );
};

CheckboxPanel.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  expandContent: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

CheckboxPanel.defaultProps = {
  checked: false,
  disabled: false,
};

export default CheckboxPanel;
